import * as React from 'react';
// Import hooks.
import {
	useInputEmail,
	UseInputEmailResults,
} from '@app/hooks/view/input';
// Import app models.
import {
	ValidatorResponse,
} from '@app/models/app';

interface UseInputMortgageeEmailParameters {
	id: string;
	infoText?: string;
	required: boolean;
	disabled: boolean;
	value: string;
	showValidation?: boolean;
	mortgageeEmailsInUse?: string[];
}

type UseInputMortgageeEmailResults = UseInputEmailResults;

const useInputMortgageeEmail = (params: UseInputMortgageeEmailParameters): UseInputMortgageeEmailResults => {

	// #region private methods

	// #region id generators

	/**
	 * Generates id for the input. 
	 **/
	const generateIdForInput = (): string => {
		return params.id;
	}

	/**
	 * Generates id for mortgagee email. 
	 **/
	const generateIdForMortgageeEmail = (): string => {
		return `${generateIdForInput()}-mortgageeEmail`;
	}

	// #endregion id generators

	/**
	 * Validates the current value.
	 * @param value
	 * @param required
	 */
	const validateMortgageeEmail_InUse = (value: string, required: boolean): ValidatorResponse => {
		let response: ValidatorResponse = new ValidatorResponse(true, String.empty());

		if (!String.isNullOrWhiteSpace(value)
			&& mortgageeEmailsInUse.some((mortgageeEmailInUse) => mortgageeEmailInUse.toLowerCase() === value.toLowerCase())) {
			response = new ValidatorResponse(false, `The specified email is already in use.`);
		}

		return response;
	}

	// #endregion private methods


	// #region variables

	const mortgageeEmailsInUse: string[] = React.useMemo(() => params.mortgageeEmailsInUse ?? [], [params.mortgageeEmailsInUse]);

	// Instantiate the 'mortgagee email' input hook.
	const mortgageeEmailInput: UseInputEmailResults = useInputEmail({
		id: generateIdForMortgageeEmail(),
		label: 'Mortgagee Email',
		infoText: params.infoText,
		required: params.required,
		disabled: params.disabled,
		value: params.value,
		showValidation: params.showValidation,
		validators: [validateMortgageeEmail_InUse],
	});

	// #endregion variables

	return mortgageeEmailInput;
}

// Export parameters.
export {
	UseInputMortgageeEmailParameters,
}

// Export results.
export {
	UseInputMortgageeEmailResults,
}

export default useInputMortgageeEmail;